import { render, staticRenderFns } from "./TopPlayers.vue?vue&type=template&id=156797a6&scoped=true&"
import script from "./TopPlayers.vue?vue&type=script&lang=js&"
export * from "./TopPlayers.vue?vue&type=script&lang=js&"
import style0 from "./TopPlayers.vue?vue&type=style&index=0&id=156797a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156797a6",
  null
  
)

export default component.exports